import * as React from 'react'

/** True below the `md` breakpoint (768px), where lists stack their rows. */
export function useBelowMd(): boolean {
  const [below, setBelow] = React.useState(false)

  React.useEffect(() => {
    const compute = () => setBelow(window.innerWidth < 768)
    compute()
    window.addEventListener('resize', compute)
    return () => window.removeEventListener('resize', compute)
  }, [])

  return below
}
